angular.module('unica_relator.relator_services')

.factory('RelatorListService', function ($http, getBaseApiURL) {

	var relatorListService = {};

	relatorListService.list = function (limit, offset)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/relator/list',
			data: {
				limit: limit,
				offset: offset
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.relators;
			}

		});

	};

	relatorListService.fullList = function ()
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/relator/full-list',
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.relators;
			}

		});
	};

	relatorListService.get = function (relatorId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/relator/detail/' + relatorId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.relator;
			}

		});
	};

	return relatorListService;
});